module.exports = __webpack_public_path__ + "img/단계목표.100d9d26.png";